import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import WelcomeScreen from './pages/WelcomeScreen';
import ProductSelection from './pages/ProductSelection';
import PreparationMethod from './pages/PreparationMethod';
import FlavorSelection from './pages/FlavorSelection';
import BurgerOption from './pages/BurgerOption';
import SideSelection from './pages/SideSelection';
import OrderReview from './pages/OrderReview';
import PaymentScreen from './pages/PaymentScreen';
import PaymentResult from './pages/PaymentResult';
import OrderConfirmation from './pages/OrderConfirmation';
import KitchenDisplay from './pages/KitchenDisplay';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

export const App = () => {
  const [order, setOrder] = useState(() => {
    const savedOrder = localStorage.getItem('pekika_order');
    return savedOrder ? JSON.parse(savedOrder) : {
      product: null,
      preparation: null,
      flavor: null,
      burger: false,
      burgerSauce: null,
      extraSides: [],
      orderId: null,
      timestamp: null
    };
  });

  useEffect(() => {
    localStorage.setItem('pekika_order', JSON.stringify(order));
  }, [order]);

  const resetOrder = () => {
    const freshOrder = {
      product: null,
      preparation: null,
      flavor: null,
      burger: false,
      burgerSauce: null,
      extraSides: [],
      orderId: null,
      timestamp: null
    };
    setOrder(freshOrder);
    localStorage.setItem('pekika_order', JSON.stringify(freshOrder));
  };

  return (
    <Router>
      <div className="App kiosk-container min-h-screen bg-background">
        <Routes>
          <Route path="/" element={<WelcomeScreen onStart={resetOrder} />} />
          <Route path="/product" element={<ProductSelection order={order} setOrder={setOrder} />} />
          <Route path="/preparation" element={<PreparationMethod order={order} setOrder={setOrder} />} />
          <Route path="/flavor" element={<FlavorSelection order={order} setOrder={setOrder} />} />
          <Route path="/burger-option" element={<BurgerOption order={order} setOrder={setOrder} />} />
          <Route path="/side" element={<SideSelection order={order} setOrder={setOrder} />} />
          <Route path="/review" element={<OrderReview order={order} setOrder={setOrder} />} />
          <Route path="/payment" element={<PaymentScreen order={order} setOrder={setOrder} />} />
          <Route path="/payment/result" element={<PaymentResult order={order} setOrder={setOrder} resetOrder={resetOrder} />} />
          <Route path="/confirmation" element={<OrderConfirmation order={order} resetOrder={resetOrder} />} />
          <Route path="/kitchen" element={<KitchenDisplay />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </div>
    </Router>
  );
};

export default App;